// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","your-gp__title":"YourGP_your-gp__title__xv5bj","your-gp__progress-container":"YourGP_your-gp__progress-container__mnSpO"};